import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import { FormControlLabel } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import moment from "moment"
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks'
import excelJS from 'exceljs'

import { ThemeProvider, createTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ModalReporteExcelComponent = (props) => {

    const [openModalReporte, setOpenModalReporte] = React.useState(true);

    const clientes = useSelector(store => store.ModuloConsulta.clientes)
    const dispatch = useDispatch()

    const handleCloseModal = () => {
        setOpenModalReporte(false)
        props.setOpenModalReporte.setOpenModalReporte()
    }

    const [tipoActividadesSelect, setTipoActividadesSelect] = React.useState([]);
    const [tipoClienteSelect, setTipoClienteSelect] = React.useState("");
    const [tipoPersonaSelect, setTipoPersonaSelect] = React.useState("");
    const [estadoSelect, setEstadoSelect] = React.useState("");

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: '90%',
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
        borderRadius: '10px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#606060"
            },
            secondary: {
                main: "#EFBF6B"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
        }
    });

    const filtrarClientesExcel = async () => {
        let filtro = clientes
        if (tipoActividadesSelect.length > 0) {
            tipoActividadesSelect.map(textoBuscar => {
                filtro = filtro?.filter((cliente) =>
                    cliente?.actividadcliente[0]?.tipoactividad?.actividad?.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente?.actividadcliente[1]?.tipoactividad?.actividad?.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente?.actividadcliente[2]?.tipoactividad?.actividad?.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente?.actividadcliente[3]?.tipoactividad?.actividad?.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente?.actividadcliente[4]?.tipoactividad?.actividad?.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente?.actividadcliente[5]?.tipoactividad?.actividad?.toLowerCase() == textoBuscar.toLowerCase()
                );
            })
        }
        if (tipoClienteSelect != "") {
            if (tipoClienteSelect == "Cliente") {
                filtro = filtro.filter((cliente) =>
                    cliente?.tipocliente?.tipocliente?.toLowerCase() == 'inscrito' ||
                    cliente?.tipocliente?.tipocliente?.toLowerCase() == 'no asociado'
                );
            }
            if (tipoClienteSelect == "Asociado") {
                filtro = filtro.filter((cliente) =>
                    cliente?.tipocliente?.tipocliente?.toLowerCase() == tipoClienteSelect.toLowerCase()
                );
            }
        }
        if (tipoPersonaSelect != "") {
            if (tipoPersonaSelect == "Persona física") {
                filtro = filtro.filter((cliente) =>
                    cliente.personafisica == true
                );
            }
            if (tipoPersonaSelect == "Persona moral") {
                filtro = filtro.filter((cliente) =>
                    cliente.personamoral == true
                );
            }
        }
        if (estadoSelect != "") {
            filtro = filtro?.filter((cliente) =>
                cliente.domiciliofiscalcliente?.filter((domicilio) => domicilio?.domicilioprincipal == true)?.[0]?.estado?.toLowerCase() == estadoSelect.toLowerCase()
            )
        }
        const clientesMap = filtro.map(cliente => {
            return [cliente.idcliente, cliente]
        });

        let clientesFiltroSinRepetidos = [...new Map(clientesMap).values()];

        reporteClientes(clientesFiltroSinRepetidos)
        /*
        let aux1 = []
        let aux2 = []
        let aux3 = []
        let aux4 = []
        
        if(tipoActividadesSelect.length == 0 && tipoClienteSelect == "" && tipoPersonaSelect == "" && estadoSelect == ""){
            aux4 = clientes
        }

        if (tipoActividadesSelect.length > 0) {
            tipoActividadesSelect.map(textoBuscar => {
                let busqueda1 = []

                busqueda1 = clientes.filter((cliente) =>
                    cliente.actividadcliente[0]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[1]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[2]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[3]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[4]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[5]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase()
                );

                aux1.push(...busqueda1)
            })
        } else {
            aux1 = clientes
        }

        if (tipoClienteSelect != "") {
            let busqueda2 = []

            if (tipoClienteSelect == "Cliente") {
                busqueda2 = aux1.filter((cliente) =>
                    cliente.tipocliente.tipocliente.toLowerCase() == 'inscrito' ||
                    cliente.tipocliente.tipocliente.toLowerCase() == 'no asociado'
                );

                aux2.push(...busqueda2)
            } else if (tipoClienteSelect == "Asociado") {
                busqueda2 = aux1.filter((cliente) =>
                    cliente.tipocliente.tipocliente.toLowerCase() == tipoClienteSelect.toLowerCase()
                );

                aux2.push(...busqueda2)
            }
        } else {
            aux2 = aux1
        }

        if (tipoPersonaSelect != "") {
            let busqueda3 = []

            if (tipoPersonaSelect == "Persona física") {
                busqueda3 = aux2.filter((cliente) =>
                    cliente.personafisica == true
                );

                aux3.push(...busqueda3)
            } else if (tipoPersonaSelect == "Persona moral") {
                busqueda3 = aux2.filter((cliente) =>
                    cliente.personamoral == true
                );

                aux3.push(...busqueda3)
            }
        } else {
            aux3 = aux2
        }

        if (estadoSelect != "") {
            aux3.map(item => {
                item?.domiciliofiscalcliente?.map(domicilio =>{
                    if(domicilio?.domicilioprincipal == true && domicilio?.estado.toLowerCase() == estadoSelect.toLowerCase()){
                        aux4.push(item)
                    }
                })
            })
        } else {
            aux4 = aux3
        }

       
        const clientesMap = aux4.map(cliente => {
            return [cliente.idcliente, cliente]
        });

        let clientesFiltroSinRepetidos = [...new Map(clientesMap).values()];

        reporteClientes(clientesFiltroSinRepetidos)*/
    }

    const reporteClientes = async (arrayClientes) => {
        const fechaHoy = moment().format('YYYY-MM-DD')
        await dispatch(actualizarLoadingApp_true())

        let arregloCliente = []
        for (const i in arrayClientes) {
            let { ...cliente } = arrayClientes?.[i]

            let tipoPersona = ''
            let tipoCliente = ''
            let actividades = []

            if (cliente.personafisica == true) tipoPersona = 'FISICA'
            else if (cliente.personamoral == true) tipoPersona = 'MORAL'

            if (cliente.tipocliente.tipocliente == "No asociado") tipoCliente = 'CLIENTE'
            else if (cliente.tipocliente.tipocliente == "Inscrito") tipoCliente = 'CLIENTE'
            else if (cliente.tipocliente.tipocliente == "Asociado") tipoCliente = 'ASOCIADO'

            cliente?.actividadcliente?.map(item =>
                actividades.push(item?.tipoactividad?.actividad)
            )

            let cadenaActividades = obtenerCadenaActividades(actividades)
            let cadenaDomicilios = obtenerDomicilios(cliente?.domiciliofiscalcliente)

            arregloCliente.push({
                numsocio: cliente?.numerosocio,
                nombrecliente: cliente?.nombrerazonsocial?.toUpperCase(),
                tipocliente: tipoCliente?.toUpperCase(),
                tipopersona: tipoPersona?.toUpperCase(),
                rfc: cliente?.rfc?.toUpperCase(),
                actividadescliente: cadenaActividades?.toUpperCase(),
                domicilio: cadenaDomicilios?.toUpperCase(),
                telefono: cliente?.telefono,
                correoelectronico: cliente?.correoelectronico?.toLowerCase(),
                nombrerepresentante: cliente?.nombrerepresentantelegal?.toUpperCase(),
                telefonorepresentante: cliente?.telefonorepresentante,
                correorepresentante: cliente?.correoelectronicorepresentante?.toLowerCase()
            })
        }

        const workbook = new excelJS.Workbook();
        const worksheet = workbook.addWorksheet("Clientes");

        let abc = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1', 'W1', 'X1', 'Y1', 'Z1'];

        worksheet.columns = [
            { header: "N° SOCIO", key: "numsocio", width: 15 },
            { header: "NOMBRE O RAZÓN SOCIAL", key: "nombrecliente", width: 40 },
            { header: "TIPO DE CLIENTE", key: "tipocliente", width: 20 },
            { header: "TIPO DE PERSONA", key: "tipopersona", width: 20 },
            { header: "RFC", key: "rfc", width: 20 },
            { header: "ACTIVIDADES CLIENTE", key: "actividadescliente", width: 30 },
            { header: "DOMICILIO", key: "domicilio", width: 50 },
            { header: "TELEFONO", key: "telefono", width: 25 },
            { header: "CORREO ELECTRONICO", key: "correoelectronico", width: 35 },
            { header: "NOMBRE REPRESENTANTE LEGAL", key: "nombrerepresentante", width: 40 },
            { header: "TELÉFONO REPRESENTANTE", key: "telefonorepresentante", width: 25 },
            { header: "CORREO REPRESENTANTE", key: "correorepresentante", width: 35 }
        ];

        abc.slice(0, 12).map(key => {
            worksheet.getCell(key).fill = {
                type: 'pattern',
                pattern: 'solid',
                height: 100,
                fgColor: { argb: '9AC4F8' }
            };
            worksheet.getCell(key).alignment = {
                vertical: 'middle',
                horizontal: 'center'
            };
        });

        arregloCliente.forEach((user) => {
            worksheet.addRow(user);
            const row = worksheet.lastRow;
            row.getCell(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(2).alignment = { vertical: 'middle', wrapText: true };
            row.getCell(3).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(4).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(5).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(6).alignment = { vertical: 'middle', wrapText: true };
            row.getCell(7).alignment = { vertical: 'middle', wrapText: true };
            row.getCell(8).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(9).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(10).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(11).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(12).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        });

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
        });

        await dispatch(actualizarLoadingApp_false())
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const blob = new Blob([buffer], { type: fileType });
            saveAs(blob, 'ReporteClientes' + fechaHoy.substring(0, 10) + EXCEL_EXTENSION);
        } catch (err) {
            console.log("error ", err)
        }
        await dispatch(actualizarLoadingApp_false())
        //setOpenModalReporte(false)
        handleCloseModal()
    }

    const obtenerCadenaActividades = (actividadcliente) => {

        let combinacionCadena = '';
        if (actividadcliente.length == 1) {
            combinacionCadena = actividadcliente[0];
        } else if (actividadcliente.length > 1) {
            combinacionCadena = actividadcliente.slice(0, -1).join(', ') + ' y ' + actividadcliente.slice(-1);
        }

        return combinacionCadena;
    }

    const obtenerDomicilios = (domiciliosCliente) => {
        let domicilios = []
        let cadenaDomicilios = '';

        domiciliosCliente?.map(domicilio => {
            domicilios.push(
                "Calle " + domicilio.calle + " núm. exterior " + domicilio.numeroexterior + " núm. interior " + domicilio.numerointerior +
                ", Colonia " + domicilio.colonia + ", Localidad " + domicilio.localidad + ", Municipio " + domicilio.municipioalcaldia +
                ", Estado de " + domicilio.estado + ", C.P. " + domicilio.codigopostal + ". "
            )
        })

        if (domicilios.length == 1) {
            cadenaDomicilios = domicilios[0];
        } else if (domicilios.length > 1) {
            cadenaDomicilios = domicilios.join("\n");
        }

        return cadenaDomicilios;
    }

    const handleChangeSelectActividades = async (event) => {
        const { target: { value }, } = event;
        setTipoActividadesSelect(value)
    };

    const handleChangeSelectCliente = (event) => {
        setTipoClienteSelect(event.target.value);
    };

    const handleChangeSelectPersona = (event) => {
        setTipoPersonaSelect(event.target.value);
    };

    const handleChangeSelectEstado = (event) => {
        setEstadoSelect(event.target.value);
    };

    const actividadesSelect = [
        'viverista',
        'Productor de maguey',
        'Productor de Mezcal',
        'Envasador',
        'Comercializador de mezcal',
        'Comercializador de bebidas con mezcal'
    ];

    const estados = [
        "Ciudad de México",
        "Aguascalientes",
        "Baja California",
        "Baja California Sur",
        "Campeche",
        "Coahuila de Zaragoza",
        "Colima",
        "Chiapas",
        "Chihuahua",
        "Durango",
        "Guanajuato",
        "Guerrero",
        "Hidalgo",
        "Jalisco",
        "México",
        "Michoacán de Ocampo",
        "Morelos",
        "Nayarit",
        "Nuevo León",
        "Oaxaca",
        "Puebla",
        "Querétaro",
        "Quintana Roo",
        "San Luis Potosí",
        "Sinaloa",
        "Sonora",
        "Tabasco",
        "Tamaulipas",
        "Tlaxcala",
        "Veracruz de Ignacio de la Llave",
        "Yucatán",
        "Zacatecas"
    ];

    return (
        <Fragment>
            <Modal
                open={openModalReporte} onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 `} style={{ textAlign: 'center' }}>
                            <h3><strong>GENERAR REPORTE DE CLIENTES</strong></h3>
                            <p>Seleccione las opciones a incluir en el reporte de Excel.</p>
                        </div>
                    </Typography>
                    <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify', fontFamily: 'Montserrat' }}>
                        <div className='row mt-3 mb-3'>
                            <ThemeProvider theme={theme}>
                                <div className='col-md-12 col-12 mt-0' style={{ backgroundColor: '#E5E5E5', height: '30px' }}>
                                    <p className='pt-1' style={{ textAlign: 'center' }}>CADENA DE ACTIVIDADES</p>
                                </div>
                                <div className="col-12 col-md-12 mt-2 mb-2 ps-5 pe-5">
                                    <FormControl sx={{ width: "100%" }} >
                                        <Select
                                            labelId="demo-multiple-checkbox-label"
                                            id="demo-multiple-checkbox"
                                            multiple
                                            displayEmpty
                                            value={tipoActividadesSelect}
                                            onChange={e => handleChangeSelectActividades(e)}
                                            input={<OutlinedInput />}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return <em>Seleccione una opción</em>;
                                                }
                                                return selected.join(', ');
                                            }}
                                        >
                                            <MenuItem disabled value="">
                                                <em>Seleccione una opción</em>
                                            </MenuItem>
                                            {actividadesSelect.map((actividad) => (
                                                <MenuItem key={actividad} value={actividad} style={{ fontFamily: 'Montserrat' }}>
                                                    <Checkbox color='success' checked={tipoActividadesSelect.indexOf(actividad) > -1} />
                                                    <ListItemText primary={actividad} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </div>
                                <div className='col-md-12 col-12 mt-3' style={{ backgroundColor: '#E5E5E5', height: '30px' }}>
                                    <p className='pt-1' style={{ textAlign: 'center' }}>TIPO DE CLIENTE</p>
                                </div>
                                <div className="col-12 col-md-12 mt-2 mb-2 ps-5 pe-5">
                                    <FormControl fullWidth>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={tipoClienteSelect}
                                            onChange={handleChangeSelectCliente}
                                            displayEmpty
                                            input={<OutlinedInput />}
                                            renderValue={(selected) => {
                                                if (selected == "") {
                                                    return <em>Seleccione una opción</em>;
                                                }
                                                return selected;
                                            }}
                                        >
                                            <MenuItem disabled value="">
                                                <em>Seleccione una opción</em>
                                            </MenuItem>
                                            <MenuItem value={"Cliente"}>
                                                <Checkbox color='success' checked={tipoClienteSelect == "Cliente"} />
                                                <ListItemText primary={"Cliente"} />
                                            </MenuItem>
                                            <MenuItem value={"Asociado"}>
                                                <Checkbox color='success' checked={tipoClienteSelect == "Asociado"} />
                                                <ListItemText primary={"Asociado"} />
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className='col-md-12 col-12 mt-3' style={{ backgroundColor: '#E5E5E5', height: '30px' }}>
                                    <p className='pt-1' style={{ textAlign: 'center' }}>TIPO DE PERSONA</p>
                                </div>
                                <div className="col-12 col-md-12 mt-2 mb-2 ps-5 pe-5">
                                    <FormControl fullWidth>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={tipoPersonaSelect}
                                            onChange={handleChangeSelectPersona}
                                            displayEmpty
                                            input={<OutlinedInput />}
                                            renderValue={(selected) => {
                                                if (selected == "") {
                                                    return <em>Seleccione una opción</em>;
                                                }
                                                return selected;
                                            }}
                                        >
                                            <MenuItem disabled value="">
                                                <em>Seleccione una opción</em>
                                            </MenuItem>
                                            <MenuItem value={"Persona física"}>
                                                <Checkbox color='success' checked={tipoPersonaSelect == "Persona física"} />
                                                <ListItemText primary={"Persona física"} />
                                            </MenuItem>
                                            <MenuItem value={"Persona moral"}>
                                                <Checkbox color='success' checked={tipoPersonaSelect == "Persona moral"} />
                                                <ListItemText primary={"Persona moral"} />
                                            </MenuItem>

                                        </Select>
                                    </FormControl>
                                </div>
                                <div className='col-md-12 col-12 mt-3' style={{ backgroundColor: '#E5E5E5', height: '30px' }}>
                                    <p className='pt-1' style={{ textAlign: 'center' }}>ESTADO</p>
                                </div>
                                <div className="col-12 col-md-12 mt-2 mb-2 ps-5 pe-5">
                                    <FormControl fullWidth>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={estadoSelect}
                                            onChange={handleChangeSelectEstado}
                                            displayEmpty
                                            input={<OutlinedInput />}
                                            renderValue={(selected) => {
                                                if (selected == "") {
                                                    return <em>Seleccione una opción</em>;
                                                }
                                                return selected;
                                            }}
                                        >
                                            <MenuItem disabled value="">
                                                <em>Seleccione una opción</em>
                                            </MenuItem>
                                            {estados.map((estado) => (
                                                <MenuItem key={estado} value={estado} style={{ fontFamily: 'Montserrat' }}>
                                                    <Checkbox color='success' checked={estadoSelect == estado} />
                                                    <ListItemText primary={estado} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-12 col-md-12 mt-3 text-center">
                                    <button type="submit" className='btn btn-success' style={{ fontFamily: 'Montserrat', width: '50%' }} onClick={() => filtrarClientesExcel()}>Aceptar</button>
                                </div>
                            </ThemeProvider>
                        </div>
                    </Typography>
                </Box>
            </Modal>
        </Fragment>
    )

}

export default withRouter(ModalReporteExcelComponent)